import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MerchantOption = (props: {
    key: number;
    merchantClass: string;
    logo: string;
    name: string;
    onChooseMerchant: () => void;
}) => {
    const { t } = useTranslation();

    const history = useHistory();

    const onMerchantClick = () => {
        props.onChooseMerchant();
        history.push("/choose-amount");
    };

    return (
        <div
            onClick={onMerchantClick}
            className={`merchants__option background-${props.merchantClass} order--${props.merchantClass}`}
        >
            <img
                className="merchants__logo"
                src={props.logo}
                alt={`${props.name}`}
            />
            <button
                type="button"
                className="voucher-button"
            >
                {t("buy")}
                <img
                    alt=""
                    className="voucher-button__icon"
                    src="assets/icons/arrow-right.svg"
                />
            </button>
        </div>
    );
};

export default MerchantOption;
